<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>

@if (qrPrintPayload | async; as qrPrintPayload) {
  @for (qrCodeItem of qrPrintPayload.qrCodesData; track qrCodeItem.orderLocation; let last = $last) {
    @if (qrPrintPayload.config.useCustomizedTemplate) {
      <div class="printme">
        <kody-qr-customize-preview
          [url]="qrCodeItem.url"
          [locationNumber]="qrCodeItem.orderLocation"
          [hasBackPage]="qrPrintPayload.config.includePrintInstruction"
          fontName="{{ qrPrintPayload.config.useWhitelabelling ? qrPrintPayload.theme?.fontFamily : undefined }}"
          themeColor="{{ qrPrintPayload.config.useWhitelabelling ? qrPrintPayload.theme?.primaryColor : undefined }}"
          [storeLogo]="qrCodeItem.store?.largeImageUrl || qrCodeItem.store?.image"
        ></kody-qr-customize-preview>
      </div>
      @if (!last || qrPrintPayload.config.includePrintInstruction) {
        <div class="pagebreak"></div>
      }
      @if (qrPrintPayload.config.includePrintInstruction) {
        <div class="printme">
          <kody-qr-customize-preview
            [url]="qrCodeItem.url"
            [locationNumber]="qrCodeItem.orderLocation"
            [isDetailsPage]="true"
            fontName="{{ qrPrintPayload.config.useWhitelabelling ? qrPrintPayload.theme?.fontFamily : undefined }}"
            themeColor="{{ qrPrintPayload.config.useWhitelabelling ? qrPrintPayload.theme?.primaryColor : undefined }}"
            [storeLogo]="qrCodeItem.store?.largeImageUrl || qrCodeItem.store?.image"
          ></kody-qr-customize-preview>
        </div>
        @if (!last) {
          <div class="pagebreak" *ngIf=""></div>
        }
      }
    } @else {
      <div class="printme">
        <kody-qr-preview [url]="qrCodeItem.url"></kody-qr-preview>
      </div>
      @if (!last) {
        <div class="pagebreak"></div>
      }
    }
  }
}
